import API from "@/utils/api"; // or the correct path to your main api.js/ts

export type RegisterPartnerPayload = {
  email: string;
  password: string;
  companyName: string;
  website: string;
};

export async function registerPartner(payload: RegisterPartnerPayload) {
  const { data } = await API.post("/partner/register", payload);
  return data;
}

export async function getPartnerMe() {
  const { data } = await API.get("/partner/me");
  return data;
}

export async function getPartnerUsage() {
  const { data } = await API.get("/partner/me/usage");
  return data;
}
export async function getPartnerEarnings() {
  const { data } = await API.get("partner/me/earnings");
  return data;
}